import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DocumentData } from 'models/DocumentLibrary';

const initialState: PdfDialogState = {
    dialog: {
        pdfUploadDialog: {
            open: false,
        },
        pdfEditDialog: {
            open: false,
            document: null,
        },
    },
    pdfUploadDialogClosedWithSuccess: false,
    pdfEditDialogClosedWithSuccess: false,
};

export const pdfDialogSlice = createSlice({
    name: 'pdfDialog',
    initialState,
    reducers: {
        setUploadDialogOpen: (
            state,
            action: PayloadAction<setUploadDialogOpenPayload>
        ) => {
            state.dialog['pdfUploadDialog'].open = action.payload.open;
        },
        setEditDialogOpen: (
            state,
            action: PayloadAction<setEditDialogOpenPayload>
        ) => {
            state.dialog['pdfEditDialog'].open = action.payload.open;
            state.dialog['pdfEditDialog'].document = action.payload.document;
        },
        setPdfUploadDialogClosedWithSuccess: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.pdfUploadDialogClosedWithSuccess = action.payload;
        },

        setPdfEditDialogClosedWithSuccess: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.pdfEditDialogClosedWithSuccess = action.payload;
        },
    },
});

export interface PdfDialogState {
    dialog: Dialogs;
    pdfUploadDialogClosedWithSuccess: boolean;
    pdfEditDialogClosedWithSuccess: boolean;
}

interface UploadDialogState {
    open: boolean;
}

interface EditDialogState {
    open: boolean;
    document: DocumentData;
}

interface Dialogs {
    pdfUploadDialog: UploadDialogState;
    pdfEditDialog: EditDialogState;
}

interface setUploadDialogOpenPayload {
    open: boolean;
}

interface setEditDialogOpenPayload {
    open: boolean;
    document: DocumentData;
}

export const pdfDialogAction = pdfDialogSlice.actions;

export default pdfDialogSlice.reducer;
